import { sendAgreement } from 'commons/service/client/application'
import { Application } from 'commons/types/DTO/commons'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSendAgreement: WriteHook<number, Application> = (opts) =>
  useMutationManager<number, Application>(sendAgreement, opts)
